export const routes = [
  {
    key: null,
    text: "Diseño de artículo",
    textCollapse: "A"
  },
  {
    key: "1",
    path: "./",
    pathlargo: "/bikitt/",
    exact: true,
    text: "articles",
    icon: "unordered-list"
  },
  {
    key: "2",
    path: "/add",
    pathlargo: "/bikitt/add",
    exact: true,
    text: "new_article",
    icon: "plus"
  },
  {
    key: null,
    text: "Diseño de proceso",
    textCollapse: "P"
  },
  {
    key: "3",
    path: "/list-design-process",
    pathlargo: "/bikitt/list-design-process",
    exact: true,
    text: "designs",
    icon: "unordered-list"
  },
  {
    key: "4",
    path: "./design-process",
    pathlargo: "/bikitt/design-process",
    exact: true,
    text: "new_design",
    icon: "plus"
  },
  {
    key: "5",
    path: "./manufacturing-order",
    pathlargo: "/bikitt/manufacturing-order",
    exact: true,
    text: "manufacturig_order",
    icon: "border"
  },
  {
    key: "6",
    path: "./control-process",
    pathlargo: "/bikitt/control-process",
    exact: true,
    text: "control_process",
    icon: "control"
  },
  {
    key: "7",
    path: "./historical",
    pathlargo: "/bikitt/historical",
    exact: true,
    text: "historical",
    icon: "bar-chart"
  }

  /*{
    key: "4",
    path: "/fabric-configuration",
    exact: true,
    text: "Fábrica",
    icon: "team"
  }*/
];
